import chatttSDK from 'services/chattt';
import posthog from '@leyan/lytics';
import { decode } from 'jsonwebtoken-esm';
import { reportRecordCache } from 'services/cache';
import { LogoutType } from './nimKick';

// 客户端设备记录账号首次使用
const recordFirst = async (
  eventName: '$deviceLogin' | '$deviceRegister',
  payload: any,
  extra: any,
) => {
  if (!chatttSDK) return;

  const reportRecord = reportRecordCache.get<Record<string, string[]>>() ?? {};

  try {
    let record = reportRecord ? reportRecord[eventName] : [];
    if (!Array.isArray(record)) {
      record = [];
    }

    if (payload?.id && !record.includes(payload.id)) {
      const appInfo = await chatttSDK?.app?.info?.();
      if (appInfo) {
        posthog.capture(eventName, {
          ...extra,
          device_type: 'desktop',
          user_id: payload?.id,
          user_name: payload?.name,
          org_id: payload?.orgId,
          language: localStorage.getItem('__tolgee_currentLanguage'),
        });

        record.push(payload.id);
        reportRecordCache.set({
          ...reportRecord,
          [eventName]: record,
        });
      }
    }
  } catch (err) {
    // do noting
  }
};

const report = async (
  eventName: '$deviceLogin' | '$deviceRegister' | '$deviceLogout',
  token: string,
  extra: {
    logoutType?: LogoutType;
    mode?:
      | 'phonePassword'
      | 'accountPassword'
      | 'registerSuccessToken'
      | 'phoneSms'
      | 'phoneRegister'
      | 'emailRegister';
  },
) => {
  if (token) {
    const payload = decode(token, { json: true });

    if (eventName === '$deviceLogin') {
      recordFirst(eventName, payload, extra);
      posthog.capture('$userLoginSuccess', {
        ...extra,
        device_type: 'desktop',
        user_id: payload?.id,
        user_name: payload?.name,
        org_id: payload?.orgId,
        language: localStorage.getItem('__tolgee_currentLanguage'),
      });
    }
    if (eventName === '$deviceRegister') {
      recordFirst(eventName, payload, extra);
      posthog.capture('$userRegisterSuccess', {
        ...extra,
        device_type: 'desktop',
        user_id: payload?.id,
        user_name: payload?.name,
        org_id: payload?.orgId,
        language: localStorage.getItem('__tolgee_currentLanguage'),
      });
    }
    if (eventName === '$deviceLogout') {
      posthog.capture('$userLogoutSuccess', {
        ...extra,
        device_type: 'desktop',
        user_id: payload?.id,
        user_name: payload?.name,
        org_id: payload?.orgId,
        language: localStorage.getItem('__tolgee_currentLanguage'),
      });
    }
  }
};

export default report;
